export default "__VITE_PUBLIC_ASSET__3422f9c0__"